<template>
  <div class="bg-black py-[7px] text-center font-base text-small text-blue-500">
    Softeo v1.0.0 - Copyright (c) 2021-2023 Prodeo - {{ t('All Right Reserved') }}
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'copyright-component',
  setup() {
    const { t } = useI18n();
    return { t };
  }
};
</script>